import { createFileRoute } from '@tanstack/react-router'

import { PlatformActivityConfigurationDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-activity-configuration-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/activity-configuration')({
  component: () => (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <PlatformActivityConfigurationDocumentationPage />
    </PermissionChecker>
  ),
})
